export const entityKeys = {
  all: ["football-entities"] as const,
  details: (entityId: string) => [...entityKeys.all, entityId] as const,
  achievements: (entityId: string) => [...entityKeys.all, entityId, "achievements"] as const,
  achievementPosts: (entityId: string, achievementId: string) =>
    [...entityKeys.all, entityId, "achievements", achievementId, "posts"] as const,
  footballFacilities: ["football-facilities"] as const,
  sports: ["goalngo-sports"] as const,
  locationsByCountry: ["football-entity-branches", "group-by-country"] as const,
  branch: (branchId: string) => ["football-entity-branches", branchId] as const,
  search: (params: URLSearchParams) => [...entityKeys.all, "search", params] as const,
} as const;
